'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserSunfire } from '../../Entities/User/UserSunfire';
import { UserSunfireCollection } from '../../Collections/User/UserSunfireCollection';

export class UserSunfireRepository extends CoreRepository {
  public getUserSunfire(userId: number, options: object = {}) {
    return this.webAPI.getUserSunfire(userId, options).then((response) => {
      const collection = new UserSunfireCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserSunfire();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserSunfire(userId: number, payload: object = {}) {
    return this.webAPI.addUserSunfire(userId, payload).then((response) => {
      const item = new UserSunfire();
      item.hydrate(response);

      return item;
    });
  }

  public updateUserSunfire(userId: number, payload: any[]) {
    return this.webAPI.updateUserSunfire(userId, payload).then((response) => {
      return response;
    });
  }

  public deleteUserSunfire(userId: number, userSunfireId: number) {
    return this.webAPI.deleteUserSunfire(userId, userSunfireId).then((response) => {
      return response;
    });
  }
}
